import type {
  RecruitmentDetailSchedule,
  RecruitmentSchedulesScheme,
} from '../../../core/entities/recruitment/schema';

export type FormattedScheduleTexts = {
  place: string | undefined;
  eventDate: string;
  deadline: string | null;
};

const DUMMY_DATE = '0001-01-01T00:00:00Z';
const WEEKDAYS = '日月火水木金土';

const formatDate = (dateStr: string, isAllDay: boolean): string | null => {
  if (!dateStr || dateStr === DUMMY_DATE) return null;
  const date = new Date(dateStr);
  const dayOfWeek = WEEKDAYS[date.getDay()];
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const time = isAllDay
    ? ''
    : `${date.getHours()}:${`0${date.getMinutes()}`.slice(-2)}`;
  return `${month}/${day}(${dayOfWeek})${time ? ` ${time}` : ''}`;
};

const formatEventDateRange = (
  start: string,
  isStartAllDay: boolean,
  end: string,
  isEndAllDay: boolean,
): string => {
  const startStr = formatDate(start, isStartAllDay) || '';
  const endStr = formatDate(end, isEndAllDay) || '';
  return [startStr, endStr].filter(Boolean).join('〜');
};

const formatDeadline = (entryEnd: string): string | null => {
  if (!entryEnd || entryEnd === DUMMY_DATE) return null;
  const now = new Date();
  const end = new Date(entryEnd);
  if (now > end) return null;
  const year = end.getFullYear().toString().slice(-2);
  const shownYear = year !== now.getFullYear().toString().slice(-2);
  const month = end.getMonth() + 1;
  const day = end.getDate();
  const dayOfWeek = end.toLocaleDateString('ja-JP', {weekday: 'short'});
  const time = end.toLocaleTimeString('ja-JP', {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${shownYear ? `${year}/` : ''}${month}/${day}(${dayOfWeek}) ${time}`;
};

export const formatScheduleTexts = (
  schedule: RecruitmentSchedulesScheme | RecruitmentDetailSchedule,
): FormattedScheduleTexts => {
  return {
    place: schedule.place,
    eventDate: formatEventDateRange(
      schedule.eventStart,
      schedule.isEventStartAllDay,
      schedule.eventEnd,
      schedule.isEventEndAllDay,
    ),
    deadline: formatDeadline(schedule.entryEnd),
  };
};
